export type SidePanelType = 'users' | 'qa' | 'chat' | 'polls' | 'content-library' | 'shared-notes';

export type SidePanelPlacement = 'left' | 'right' | 'bottom';

export type SidePanelData = Record<string, any>;

export type BroadcastMessageFormType = 'lobby' | 'breakoutRooms';

export const MAX_PINNED_PANELS = 2;

export const DEFAULT_SPLIT_RATIO = 0.5;

export interface SidePanelState {
  activePanel: SidePanelType | null;
  pinnedPanels: SidePanelType[];
  remotePinnedPanels: SidePanelType[];
  pinnedSplitRatio: number;
  data: SidePanelData;
  placement: SidePanelPlacement;
  broadcastMessageForm: BroadcastMessageFormType | null;
}
